import agentGetDeviceIdNameList from "@/api/device/charging-pile-manage/agentGetDeviceIdNameList";
import getMonthlyByDeviceId from "@/api/device/monthly-manage/getMonthlyByDeviceId";

export default {
    data() {
        return {
            monthlyInfoList: [{
                id: null,
                freeDayNum: null,
                freeChargeNum: null,
                startPower: null,
                endPower: null,
                money: null
            }],
            checked: true,
            id: undefined,
            loading: false,
            options: [],
        }
    },
    methods: {
        change(val) {
            getMonthlyByDeviceId(val).then(res => {
                if (res.data.length === 0) {
                    this.monthlyInfoList = [{
                        id: null,
                        freeDayNum: null,
                        freeChargeNum: null,
                        startPower: null,
                        endPower: null,
                        money: null
                    }];
                    this.monthForm.monthlyInfoId = undefined;
                    this.checked = true;
                } else {
                    this.monthlyInfoList = res.data;
                    this.checked = false;
                }
            });
        },
        fetchDevice(query) {
            if (query !== '') {
                this.loading = true;
                agentGetDeviceIdNameList({name: query}).then(res => {
                    this.options = res.data;
                    this.loading = false;
                })
            } else {
                this.options = [];
            }
        },
    },
}
